(function () {
  function isProductPage() {
    return document.body && (
      document.body.classList.contains('template-product') ||
      String(document.body.className || '').indexOf('template-product') !== -1 ||
      location.pathname.indexOf('/products/') !== -1
    );
  }

  function text(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function important(el, prop, val) {
    try { el.style.setProperty(prop, val, 'important'); } catch (e) {}
  }

  function relatedRoot() {
    var headings = Array.from(document.querySelectorAll('h1,h2,h3,h4,.section-title,.title'));
    for (var i = 0; i < headings.length; i++) {
      var t = text(headings[i]);
      if (t.indexOf('related products') !== -1 || t.indexOf('you may also need') !== -1 || t.indexOf('more from this department') !== -1) {
        var n = headings[i];
        for (var up = 0; up < 7 && n; up++, n = n.parentElement) {
          if (n && n.querySelectorAll && n.querySelectorAll('img').length >= 2 && n.querySelectorAll('a,button').length >= 4) return n;
        }
      }
    }
    return document.querySelector('.related-product-area, .related-products, .product-recommendations');
  }

  function closestCard(el, root) {
    var n = el;
    for (var i = 0; i < 10 && n && n !== root; i++, n = n.parentElement) {
      if (!n.querySelectorAll) continue;
      if (n.querySelector('img') && n.querySelectorAll('a,button').length >= 2) return n;
    }
    return null;
  }

  function commonParent(a, b, card) {
    var n = a.parentElement;
    while (n && n !== card) {
      if (n.contains(b)) return n;
      n = n.parentElement;
    }
    return a.parentElement || b.parentElement;
  }

  function apply() {
    if (!isProductPage()) return;

    var root = relatedRoot();
    if (!root) return;

    var cards = [];
    Array.from(root.querySelectorAll('a,button')).forEach(function (el) {
      if (text(el) !== 'add to cart' && text(el) !== 'details') return;
      var card = closestCard(el, root);
      if (card && cards.indexOf(card) === -1) cards.push(card);
    });

    cards.forEach(function (card) {
      var buttons = Array.from(card.querySelectorAll('a,button'));
      var add = buttons.find(function (b) { return text(b) === 'add to cart'; });
      var details = buttons.find(function (b) { return text(b) === 'details'; });
      if (!add || !details) return;

      var wrap = commonParent(add, details, card);
      if (!wrap) return;

      wrap.classList.add('stahlor-related-buttons-stack-v6');

      important(wrap, 'display', 'flex');
      important(wrap, 'flex-direction', 'column');
      important(wrap, 'gap', '10px');
      important(wrap, 'width', '210px');
      important(wrap, 'max-width', '210px');
      important(wrap, 'margin', '18px auto 0');
      important(wrap, 'align-items', 'stretch');
      important(wrap, 'position', 'static');
      important(wrap, 'transform', 'none');
      important(wrap, 'opacity', '1');
      important(wrap, 'visibility', 'visible');

      [add, details].forEach(function (btn) {
        important(btn, 'width', '210px');
        important(btn, 'min-width', '210px');
        important(btn, 'max-width', '210px');
        important(btn, 'height', '42px');
        important(btn, 'min-height', '42px');
        important(btn, 'max-height', '42px');
        important(btn, 'padding', '0 14px');
        important(btn, 'border-radius', '11px');
        important(btn, 'display', 'flex');
        important(btn, 'align-items', 'center');
        important(btn, 'justify-content', 'center');
        important(btn, 'text-align', 'center');
        important(btn, 'white-space', 'nowrap');
        important(btn, 'overflow', 'hidden');
        important(btn, 'font-size', '13px');
        important(btn, 'font-weight', '800');
        important(btn, 'line-height', '1');
        important(btn, 'box-sizing', 'border-box');
      });

      add.classList.add('stahlor-related-add-v6');
      details.classList.add('stahlor-related-details-v6');

      important(add, 'background', '#f7b500');
      important(add, 'border', '1px solid #f2aa00');
      important(add, 'color', '#111827');

      important(details, 'background', '#eef3f8');
      important(details, 'border', '1px solid #e5ebf2');
      important(details, 'color', '#132033');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 900);
    setTimeout(apply, 1800);
  });

  try {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();